import React from 'react';
import { Link } from 'react-router-dom';

function LegalSidebar({ activePage }) {
  return (
    <aside className="terms-sidebar">
      <nav className="sidebar-nav">
        <Link to="/terms-of-use" className={activePage === 'terms-of-use' ? 'active' : ''}>
          1. Website terms of use
        </Link>
        <Link to="/terms-and-condition" className={activePage === 'terms-and-condition' ? 'active' : ''}>
          2. Terms and conditions
        </Link>
        <Link to="/privacy-policy" className={activePage === 'privacy-policy' ? 'active' : ''}>
          3. Privacy policy
        </Link>
        <Link to="/cookie-policy" className={activePage === 'cookie-policy' ? 'active' : ''}>
          4. Cookie policy
        </Link>
        <Link to="/third-party-links" className={activePage === 'third-party-links' ? 'active' : ''}>
          5. Third Party Links
        </Link>
        <Link to="/gdpr" className={activePage === 'gdpr' ? 'active' : ''}>
          6. GDPR
        </Link>
      </nav>
    </aside>
  );
}

export default LegalSidebar;
